/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Priority_HeaderInputs */

const en_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const fr_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const de_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const it_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const ru_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const es_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const zh_cn2_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const ja_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const hi_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const pt_pt2_explorer_table_priority_header = /** @type {(inputs: Explorer_Table_Priority_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Explorer_Table_Priority_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_priority_header = /** @type {((inputs?: Explorer_Table_Priority_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Priority_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_priority_header(inputs)
	if (locale === "de") return de_explorer_table_priority_header(inputs)
	if (locale === "it") return it_explorer_table_priority_header(inputs)
	if (locale === "ru") return ru_explorer_table_priority_header(inputs)
	if (locale === "es") return es_explorer_table_priority_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_priority_header(inputs)
	if (locale === "ja") return ja_explorer_table_priority_header(inputs)
	if (locale === "hi") return hi_explorer_table_priority_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_priority_header(inputs)
	return en_explorer_table_priority_header(inputs)
});